export class UnitOfServiceRecord {
    id: number;
    unitOfServiceId: number;
    shiftBlockId: number;
    workflowTime: string;
    workflowTimeFacility: string;
    total: number;
    isProjected: boolean;
    importedAmount: number | null;
}